import isDateEqual from '@afosto/utils/date/isDateEqual';

export default (dateString, operator) => {
  if (!dateString) {
    return false;
  }

  const dateValue = new Date(dateString);

  const today = new Date();
  const tomorrow = new Date(today);
  const yesterday = new Date(today);

  tomorrow.setDate(tomorrow.getDate() + 1);
  yesterday.setDate(yesterday.getDate() - 1);

  if (operator === 'gt') {
    return isDateEqual(dateValue, tomorrow);
  }

  return isDateEqual(dateValue, today);
};
